var exports = {
  "kL": "x4ddf2309--04ac58--container",
  "pq": "x4ddf2309--04ac58--info",
  "h4": "x4ddf2309--04ac58--short_name",
  "Gz": "x4ddf2309--04ac58--full_name",
};

module.exports = exports;
